import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

function EditableDropdown({options, value, onChange, ...textFieldProps}) {
  const { InputProps, ...restTextFieldProps } = textFieldProps;

  if (!options || options.length === 0) {
    return (<TextField value={value ?? ""}
                      onChange={e => onChange(e.target.value)}
                      {...textFieldProps}
    />
    );
  }
  return (
    <Autocomplete
      value={value ?? null}
      getOptionLabel={(option) => String(option, "")} // display label
      isOptionEqualToValue={(option, value) => option === value} // compare by value
      onChange={(_, newValue) => onChange(newValue)}
      freeSolo // This enables typing values not in the options
      options={options}
      renderInput={(params) => (
        <TextField
            {...params}
            {...restTextFieldProps}
            InputProps={{
                ...params.InputProps, // keep autocomplete wiring
                style: { fontSize: "1.2rem" },
            }}
            onChange={e => onChange(e.target.value)} />
      )}
      slotProps={{
          paper: {
              sx: {
                  "& .MuiAutocomplete-option": {
                      fontSize: "1.3rem",   // Each option font size
                      padding: "10px 16px"
                  }
              }
          }
      }}
    />
  );
}

export default EditableDropdown;